module.exports = __webpack_public_path__ + "static/media/nikon_bookf.99fa2822.png";